import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import '../../assets/saas/atoms/_floatingbuttons.scss';
const FloatingButton = ({ children, }) => {
    const buttonRef = useRef(null);
    useEffect(() => {
        if ('virtualKeyboard' in navigator) {
            navigator.virtualKeyboard.overlaysContent = true;
        }
    }, []);
    // const buttonStyle: React.CSSProperties = {
    //   position: window.innerWidth < 992 ? "fixed" : "static",
    //   width: 'max(100%, env(keyboard-inset-width, 0rem))',
    //   padding: '0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)',
    //   left: 0,
    //   right: 0,
    //   bottom: '0.5rem',
    //   height: '4.5rem',
    //   zIndex: 9999,
    //   transition: "bottom 0.2s ease-in-out",    
    //   ...style,
    // };
    return (_jsx("div", { className: 'floating-button-container', ref: buttonRef, children: children }));
};
export default FloatingButton;
